// src/api/quotationHistoryApi.ts

import apiHandler from '../core/apiHandler';

const quotationHistoryApi =
    apiHandler('quotations/history');

export default quotationHistoryApi;